import { Injectable } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { HttpService } from './http.service';
import { CustomerDocumentModalComponent } from '../components/customer-document-modal/customer-document-modal.component';
import { CustomerPhoneModalComponent } from '../components/customer-phone-modal/customer-phone-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private httpSrvc: HttpService
  ) {}

  async presentAlert(
    message: string,
    icon: string,
    color: string,
    route?: string,
    back?: boolean,
    okText = 'Ok'
  ) {
    // Determina a classe CSS baseada na cor
    let alertClass = 'custom-alert custom-alert-desktop';
    if (color.includes('color-dg') || color.includes('danger')) {
      alertClass += ' custom-alert-error';
    } else if (color.includes('color-wn') || color.includes('warning')) {
      alertClass += ' custom-alert-warning';
    } else if (color.includes('color-pr') || color.includes('primary') || color.includes('success')) {
      alertClass += ' custom-alert-success';
    } else {
      alertClass += ' custom-alert-info';
    }

    const alert = await this.alertCtrl.create({
      message: message,
      cssClass: alertClass,
      mode: 'ios',
      buttons: [
        {
          text: okText,
          cssClass: 'button-close',
          handler: () => {
            if (back) {
              this.navCtrl.navigateBack(route);
            } else if (route) {
              this.navCtrl.navigateForward(route);
            }
          },
        },
      ],
      backdropDismiss: false,
    });
    await alert.present();
    return alert;
  }

  /** Retorna true se o usuário tem um telefone válido (10 ou 11 dígitos). */
  hasValidPhone(user: any): boolean {
    const raw = (user?.phone || '').toString().replace(/\D/g, '');
    const digits = raw.startsWith('55') ? raw.slice(2) : raw;
    return digits.length >= 10 && digits.length <= 11;
  }

/*   async checkAndRequestDocument(user, backdropDismiss = true, requestAgain = false, isCheckoutContext = false) {
    const isAsaasCustomer = user?.customerId?.startsWith('cus_');
    if (!isAsaasCustomer || !user?.customerId) {
      const customerData = {
        email: user.email,
        name: user.name,
        external_id: user.id,
        phone_numbers: ['+' + user.phone],
        documents: [{ type: '', number: 0 }],
        type: 'individual',
        country: 'br',
      };
      const alert = await this.alertCtrl.create({
        header: 'Selecione o tipo do seu documento',
        cssClass: 'custom-alert',
        mode: 'ios',
        backdropDismiss,
        buttons: [
          {
            text: 'CNPJ',
            cssClass: 'button-confirm',
            handler: () => {
              customerData.documents[0].type = 'cnpj';
              customerData.type = 'corporation';
            },
          },
          {
            text: 'CPF',
            cssClass: 'button-confirm',
            handler: () => {
              customerData.documents[0].type = 'cpf';
              customerData.type = 'individual';
            },
          },
        ],
      });
      await alert.present();
      await alert.onDidDismiss();
      if (!customerData.documents[0].type) {
        return;
      }
      const alert2 = await this.alertCtrl.create({
        header: 'Digite seu ' + customerData.documents[0].type.toUpperCase(),
        cssClass: 'custom-alert',
        mode: 'ios',
        backdropDismiss,
        inputs: [
          {
            name: 'value',
            type: 'number',
            placeholder: customerData.documents[0].type.toUpperCase(),
          },
        ],
        buttons: [
          {
            text: 'Ok',
            cssClass: 'button-close',
            handler: (data) => {
              customerData.documents[0].number = data.value;
            },
          },
        ],
      });
      await alert2.present();
      await alert2.onDidDismiss();
      if (
        !this.documentIsValid(
          customerData.documents[0].type.toUpperCase(),
          customerData.documents[0].number
        )
      ) {
        const alert3 = await this.alertCtrl.create({
          header: 'O documento digitado é inválido, tente novamente',
          cssClass: 'custom-alert',
          mode: 'ios',
          backdropDismiss,
          buttons: [
            {
              text: 'Ok',
              cssClass: 'button-close',
            },
          ],
        });
        await alert3.present();
        await alert3.onDidDismiss();
        if (requestAgain) {
          await this.checkAndRequestDocument(user, backdropDismiss, requestAgain);
        }
        return;
      }
      const addressNumber = user?.address?.line_1?.split(',')[0] || '';
      const phoneNumber = customerData.phone_numbers[0].replace('+55', '');
      const payload = {
        name: user.name,
        email: user.email,
        cpfCnpj: customerData.documents[0].number,
        mobilePhone: phoneNumber,
        postalCode: user.address.zip_code,
        addressNumber: addressNumber,
        complement: user.address.compliment,
        externalReference: user.id,
      };
      console.log(payload);
      user.customerId = (
        (await this.httpSrvc.post('customer', payload).toPromise()) as any
      ).id;
      const storageItem = JSON.parse(localStorage.getItem('userDB'));
      storageItem.user = user;
      localStorage.setItem('userDB', JSON.stringify(storageItem));
    }
    return await this.httpSrvc.get('customer/' + user.customerId).toPromise();
  } */

  async checkAndRequestDocument(user, backdropDismiss = true, requestAgain = false, isCheckoutContext = false, skipDocumentModal = false) {
    let currentUser = user;
    if (currentUser?.id && !this.hasValidPhone(currentUser)) {
      const phoneModal = await this.modalCtrl.create({
        component: CustomerPhoneModalComponent,
        componentProps: { user: currentUser },
        cssClass: 'customer-phone-modal',
        backdropDismiss: false,
      });
      await phoneModal.present();
      const { data } = await phoneModal.onDidDismiss();
      if (data?.saved) {
        const userDB = JSON.parse(localStorage.getItem('userDB') || '{}');
        currentUser = userDB?.user || userDB;
      }
    }

    const isAsaasCustomer = currentUser?.customerId?.startsWith('cus_');
    if (!isAsaasCustomer || !currentUser?.customerId) {
      // Usa exclusivamente o documento do próprio comprador. NÃO herdar o
      // documento do vendedor: isso fazia o CNPJ do lojista/iPlanta ser usado
      // como se fosse do cliente no pedido/emissão de NF. Sem documento próprio,
      // o cliente deve informá-lo no modal.
      const savedDocument = currentUser?.cpfCnpj || currentUser?.document;
      console.log('[checkAndRequestDocument] Saved document:', savedDocument);

      if (savedDocument) {
        console.log('[checkAndRequestDocument] User has saved document, creating customer silently...');
        console.log('[checkAndRequestDocument] Document:', savedDocument);

        // Determine document type based on length
        const cleanDocument = savedDocument.toString().replace(/\D/g, '');
        const documentType = cleanDocument.length === 11 ? 'CPF' : 'CNPJ';

        // Validate document
        if (this.documentIsValid(documentType, cleanDocument)) {
          console.log('[checkAndRequestDocument] Document is valid, proceeding with customer creation...');

          try {
            const addressNumber = currentUser?.address?.line_1?.split(',')[0] || '';
            const phoneNumber = (currentUser?.phone || '').toString().replace(/^\+?55/, '');

            const payload = {
              name: currentUser.name,
              email: currentUser.email,
              cpfCnpj: cleanDocument,
              mobilePhone: phoneNumber,
              postalCode: currentUser?.address?.zip_code || '',
              addressNumber: addressNumber,
              complement: currentUser?.address?.compliment || '',
              externalReference: currentUser.id,
            };

            console.log('[checkAndRequestDocument] Creating customer with payload:', payload);

            const response: any = await this.httpSrvc.post('customer', payload).toPromise();
            console.log('[checkAndRequestDocument] Customer created successfully:', response);

            currentUser.customerId = response.id;
            currentUser.cpfCnpj = cleanDocument;

            // Update localStorage
            const storageItem = JSON.parse(localStorage.getItem('userDB') || '{}');
            if (storageItem.user) {
              storageItem.user.customerId = response.id;
              storageItem.user.cpfCnpj = cleanDocument;
            } else {
              storageItem.customerId = response.id;
              storageItem.cpfCnpj = cleanDocument;
            }
            localStorage.setItem('userDB', JSON.stringify(storageItem));

            // Persiste o CPF/CNPJ no perfil do usuário (necessário para emissão de NF).
            const userOpts = this.httpSrvc.getOpts();
            if (userOpts && currentUser?.id && !(user?.cpfCnpj || user?.document)) {
              try {
                await this.httpSrvc.put('user/' + currentUser.id, { cpfCnpj: cleanDocument }, userOpts).toPromise();
              } catch (e) {
                console.error('[checkAndRequestDocument] Falha ao salvar CPF no perfil do usuário', e);
              }
            }

            console.log('[checkAndRequestDocument] Customer ID saved to localStorage');
            return await this.httpSrvc.get('customer/' + currentUser.customerId).toPromise();
          } catch (error) {
            console.error('[checkAndRequestDocument] Error creating customer silently:', error);
            // Fall through to modal if silent creation fails
          }
        } else {
          console.log('[checkAndRequestDocument] Saved document is invalid, falling back to modal');
        }
      }

      // No fluxo de cartão de crédito o documento é coletado no próprio
      // formulário do cartão (Dados do Titular). Evitamos a tela redundante de
      // documento e deixamos o cliente Asaas ser criado no envio do cartão.
      if (skipDocumentModal) {
        console.log('[checkAndRequestDocument] Skipping document modal (collected in card form)');
        return;
      }

      // Fallback to modal if no saved document or silent creation failed
      console.log('[checkAndRequestDocument] Opening document modal...');
      const modal = await this.modalCtrl.create({
        component: CustomerDocumentModalComponent,
        componentProps: { user: currentUser, requestAgain, isCheckoutContext },
        cssClass: 'customer-document-modal',
        backdropDismiss: !!backdropDismiss,
      });
      await modal.present();
      const { data } = await modal.onDidDismiss();
      if (!data?.customer) {
        return;
      }
      return data.customer;
    }
    return await this.httpSrvc.get('customer/' + currentUser.customerId).toPromise();
  }

  documentIsValid(type: string, document: string | number) {
    const digits = document
      .toString()
      .replace(/\D/g, '')
      .split('')
      .map((i) => Number(i));
    let digitsSum = 0;
    let sameNumbers = 0;
    if (type === 'CPF') {
      if (digits.length !== 11) {
        return false;
      }

      for (let i = 0; i < 9; i++) {
        digitsSum += digits[i] * (10 - i);
      }

      for (let i = 0; i < 11; i++) {
        if (digits[i] === digits[0]) {
          sameNumbers++;
        }
      }

      let verificatorDigit = (digitsSum * 10) % 11;
      if (digits[9] !== (verificatorDigit > 9 ? 0 : verificatorDigit) || sameNumbers > 10) {
        return false;
      }

      digitsSum = 0;
      for (let i = 0; i < 10; i++) {
        digitsSum += digits[i] * (11 - i);
      }
      verificatorDigit = (digitsSum * 10) % 11;
      return digits[10] === (verificatorDigit > 9 ? 0 : verificatorDigit);
    }
    if (type === 'CNPJ') {
      if (digits.length !== 14) {
        return false;
      }
      let multiplier = 5;
      for (let i = 0; i < digits.length; i++) {
        if (i >= 12) {
          break;
        }
        if (multiplier === 1) {
          multiplier = 9;
        }
        digitsSum += digits[i] * multiplier;
        multiplier--;
      }
      let verificatorDigit = digitsSum % 11 < 2 ? 0 : 11 - (digitsSum % 11);
      if (verificatorDigit !== digits[12]) {
        return false;
      }
      digitsSum = 0;
      multiplier = 6;
      for (let i = 0; i < digits.length; i++) {
        if (i >= 13) {
          break;
        }
        if (multiplier === 1) {
          multiplier = 9;
        }
        digitsSum += digits[i] * multiplier;
        multiplier--;
      }
      verificatorDigit = digitsSum % 11 < 2 ? 0 : 11 - (digitsSum % 11);
      return verificatorDigit === digits[13];
    }
  }
}
